import React from 'react';

import ColBase from 'antd/lib/col';

const Col = ({ ...props }) => <ColBase {...props} />

export default Col;